import { PROBLEM_DEFINITION_TOOLS } from './problemDefinition';
import { SOLUTION_TESTING_TOOLS } from './solutionTesting';
import { MVP_CREATION_TOOLS } from './mvpCreation';
import { LAUNCH_EXPERIMENT_TOOLS } from './launchExperiment';
import { SCALABLE_GROWTH_TOOLS } from './scalableGrowth';
import { ProjectStage } from '../stages';

export const STAGE_TOOLS = {
  [ProjectStage.PROBLEM_DEFINITION]: PROBLEM_DEFINITION_TOOLS,
  [ProjectStage.SOLUTION_TESTING]: SOLUTION_TESTING_TOOLS,
  [ProjectStage.MVP_CREATION]: MVP_CREATION_TOOLS,
  [ProjectStage.LAUNCH_EXPERIMENT]: LAUNCH_EXPERIMENT_TOOLS,
  [ProjectStage.SCALABLE_GROWTH]: SCALABLE_GROWTH_TOOLS
}; 